import { useEffect, useState } from 'react';
import closeIcon from 'assets/images/close-icon.svg';
import allImgPaths from 'assets/images';
import CustomCheckBox from 'components/CustomCheckBox';
import { addAttendeeFromList, deleteAttendees, fileUploadList, listData, updateAttendee } from 'services/event';
import { cloneDeep } from 'lodash';
import { ExistingSettingMemberLoader } from 'components/loaders';
import { extractJSONFromText } from 'utils/function';
import { useParams } from 'react-router-dom';
import ConfirmationModal from './common/modal/ConfirmationModal';
import Toast from './common/Toast';
import CustomSelect from './common/CustomSelect';
import React from "react";
import Select from 'react-select/dist/declarations/src/Select';
import { customSelectStyle } from 'utils/style';

const pageOptions = [
    10, 50, 100, 500
]

const initEditData = {
    name: '',
    email: ''
}

// const ViewListItem = ({ data: templateData, ids, setShowListModal, type, category }: any) => {
const ViewListItem = ({ messageData = {} }: any) => {
    let { content: messageContent } = messageData;
    const jsonDetails = messageContent ? extractJSONFromText(messageContent) : {};
    const { id: eventId, draftEventId } = useParams();
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [allSelected, setAllSelected] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [perPage, setPerPage] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [finalPage, setFinalPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalEmailSent, setTotalEmailSent] = useState(0)
    const [showDismissBox, setShowDismissBox] = useState(false);
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const [initListPayload, setInitListPayload] = useState<any>({
        event_id: eventId,
        perPage: perPage,
        page: currentPage,
        category: jsonDetails?.category,
        // file_name: [jsonDetails?.file_name]
    })
    const [originalData, setOriginalData] = useState<any>([])

    const [optionsSelected, setOptionsSelected] = useState(null)
    const [currentSort, setCurrentSort] = useState(0)
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [totalSelected, setTotalSelected] = useState(0)
    const [formData, setFormData] = useState<any>(null)
    const [allFileList, setAllFileList] = useState<any>([]);
    const [selectedFiles, setSelectedFiles] = useState<any>(jsonDetails?.file_name ? [jsonDetails?.file_name] : []);
    const [allFileSelected, setAllFileSelected] = useState(false);
    const [showFilesData, setShowFilesData] = useState(false)
    const [isEditMode, setIsEditMode] = useState(jsonDetails?.isEditMode ? true : false)
    const [singleSelectedFile, setSingleSelectedFile] = useState<any>(null)
    const [isAddNew, setIsAddNew] = useState(false);

    const optionsList = [
        { value: 'yes', label: 'Yes, already included.' },
        { value: 'no_other', label: 'No, I want other vendors for that.' },
        { value: 'no_missed', label: 'No, I missed. Can we include now?' }
    ]
    const [sortOrder, setSortOrder] = useState('asc');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [allKeys, setAllKeys] = useState<any>([]);
    const [sortField, setSortField] = useState<any>(null);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleInput = (e: any) => {
        if (!e.target.value) {
            setSearchText('');
            handleSearch(e, true)
        }
    }

    // On First Load
    useEffect(() => {
        if (jsonDetails?.file_name) {
            setFilePayload([jsonDetails?.file_name])
            setShowFilesData(true)
        } else {
            getAllFileList()
        }
    }, [jsonDetails?.content?.newMessageId, jsonDetails?.file_name])

    useEffect(() => {
        if (singleSelectedFile) {
            setFilePayload(selectedFiles)
        }
    }, [singleSelectedFile])

    // Fetch all the file list uniquely
    const getAllFileList = async () => {
        const { data } = await fileUploadList({ event_id: eventId, from_board: false })
        console.log({ data })
        let allFilesListOptions: any[] = []
        if (data?.length) {
            // data.map((dt: any) => {
            //     dt['selected'] = false;
            // });

            data.map((dt: any) => {
                allFilesListOptions.push({
                    id: dt.file_name,
                    label: dt?.original_file_name || dt?.file_name,
                    value: dt.file_name
                })
            })

            console.log({ allFilesListOptions })

            setAllFileList(allFilesListOptions)
        } else {
            setAllFileList([])
        }
    }

    // Setup payload for fetching attendee list of the selected file
    const setFilePayload = (files: any[]) => {
        const updatedListPayload = cloneDeep(initListPayload);
        updatedListPayload['category'] = jsonDetails.category;
        updatedListPayload['file_name'] = files;

        setInitListPayload(updatedListPayload)
        fetchList(updatedListPayload)
    }

    // Fetch attendee list data for selected files
    const fetchList = async (listPayload: any) => {
        // console.log({ listPayload })
        setLoading(true)

        try {
            const { data } = await listData(listPayload)
            const updatedData = setListData(data?.data)
            setTotalData(data?.length)
            setCurrentPage(listPayload.page)
            setFinalPage(Math.ceil(data?.length / listPayload.perPage))
            console.log({ attendeeData: updatedData })
            setData(updatedData)
            setOriginalData(cloneDeep(updatedData))
            setLoading(false)
            setShowFilesData(true)
        } catch (error) {
            setLoading(false)
            setListData([])
        }
    }

    const setListData = (data: any[]) => {
        if (data?.length) {
            data.map((dt: any) => {
                dt['selected'] = false;
                dt['isEditMode'] = false
            });

            const uniqueKeys = new Set();
            data.forEach(item => {
                if (item.all_data) {
                    Object.keys(item.all_data).forEach(key => uniqueKeys.add(key));
                }
            });
            const allKeysData = [...Array.from(uniqueKeys), 'Action']
            let orderedKeys = [
                "first name",
                "last name",
                "email",
                ...allKeysData.filter((item: any) => !["first name", "last name", "email"].includes(item))
            ];
            console.log({ orderedKeys })
            setAllKeys(orderedKeys)

            return data
        }
        return []
    }

    // Handle selection of attendee list data
    const handleSelection = (id: string, isChecked: boolean) => {
        let clonedData: any[] = cloneDeep(data);
        if (id != 'all') {
            const index = clonedData.findIndex((cd: any) => JSON.stringify(cd._id) == JSON.stringify(id));
            if (index > -1) {
                clonedData[index]['selected'] = isChecked;
            }

            // Set top checkbox status
            if (!isChecked) setAllSelected(false)

            const allSelected = clonedData.every((cd: any) => cd.selected);
            if (allSelected) setAllSelected(true)

        } else {
            clonedData = clonedData.map((cd: any) => ({ ...cd, selected: isChecked }))
            setAllSelected(isChecked)
        }

        setData(clonedData);

        if (clonedData.some((cd: any) => cd.selected)) {
            setBtnDisabled(false)
        } else {
            setBtnDisabled(true)
        }

        const totalSelections = clonedData.filter((cd: any) => cd?.selected);
        setTotalSelected(totalSelections.length)
    }

    // Handle search of attendee list data
    const handleSearch = async (e: any, fromClose = false) => {
        e.preventDefault()
        const text = fromClose ? '' : (searchText ? searchText.trim() : '');
        const clonedListPayload: any = cloneDeep(initListPayload);
        clonedListPayload['query'] = text;
        setInitListPayload(clonedListPayload)
        await fetchList(clonedListPayload)
    }

    // Handle page change of attendee list data
    const handlePageChange = async (page: number) => {
        if (page > 0) {
            const clonedListPayload: any = cloneDeep(initListPayload);
            clonedListPayload['page'] = page;

            setInitListPayload(clonedListPayload)
            await fetchList(clonedListPayload)
        }
    }

    // Handle sorting of attendee list data
    const [arrowUp, setArrowUp] = useState(false);
    const handleSort = (type: string) => {
        const sortedData = [...data].sort((a, b) => {
            if (type == 'sentTime') {
                const dateA: any = new Date(a.sentTime);
                const dateB: any = new Date(b.sentTime);
                if (sortOrder === 'asc') {
                    return dateA - dateB;
                } else {
                    return dateB - dateA;
                }
            } else {
                if (sortOrder === 'asc') {
                    return a['all_data'][type].localeCompare(b['all_data'][type]);
                } else {
                    return b['all_data'][type].localeCompare(a['all_data'][type]);
                }
            }
        });
        setData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');

        setArrowUp(!arrowUp);
        setSortField(type);
    };

    // Handle per page change of attendee list data
    const handlePerPageChange = async (e: any) => {
        const value = +e.target.value;
        if (value != perPage) {
            const clonedListPayload: any = cloneDeep(initListPayload);
            clonedListPayload['perPage'] = value;
            clonedListPayload['page'] = 1;
            setInitListPayload(clonedListPayload)
            await fetchList(clonedListPayload);

            setPerPage(value)
        }
    }

    const deleteItemModal = () => {
        setShowDeleteModal(true)
    }

    const confirmDelete = async () => {
        const ids = data.filter((dt: any) => dt?.selected).map((dt: any) => dt._id);
        if (ids?.length) {
            const deletePayload = {
                ids, event_id: eventId
            }
            try {
                await deleteAttendees(deletePayload);
                await handleSearch(false)
            } catch (error) {
                console.log({ deleteError: error })
            }
        }

        setShowDeleteModal(false)
    }

    const editItem = (id: any) => {
        if (isAddNew) return;

        const index = data.findIndex((dt: any) => JSON.stringify(dt._id) == JSON.stringify(id));
        if (index > -1) {
            console.log({ id, index })
            let clonedData = cloneDeep(data);

            clonedData = clonedData.map((cd: any, cIndex: number) => {
                cd['isEditMode'] = index == cIndex ? true : false
                return cd
            })

            setData(clonedData);

            let editObjects = clonedData[index].all_data;
            delete editObjects['Action'];
            setFormData(editObjects)
        }
    }

    const cancelEditItem = (id: any) => {
        if (isAddNew) {
            setIsAddNew(false);
            const clonedData = cloneDeep(data);
            clonedData.splice(0, 1);
            setData(clonedData)
        } else {
            const index = data.findIndex((dt: any) => JSON.stringify(dt._id) == JSON.stringify(id));
            if (index > -1) {
                const clonedData = cloneDeep(data);
                clonedData[index]['isEditMode'] = false;
                setData(clonedData)
                setFormData(null)
            }
        }
    }

    const confirmEditItem = async (id: any) => {
        // Validate data
        const isValid = validateData()
        if (!isValid) return

        const index = data.findIndex((dt: any) => JSON.stringify(dt._id) == JSON.stringify(id));
        if (index > -1) {
            const clonedData = cloneDeep(data);
            clonedData[index]['isEditMode'] = false;

            clonedData[index] = {
                ...clonedData[index],
                all_data: formData
            }

            console.log({ formData })
            setData(clonedData);

            const updatePayload = {
                payload: clonedData[index].all_data
            }

            try {
                await updateAttendee(id, { event_id: eventId, ...updatePayload })
                Toast.success('', 'Data updated successfully')
            } catch (error) {
                Toast.error('', 'Failed to updated data')
            }

        }
    }

    const handleTextChange = (name: any, value: any) => {
        setFormData({ ...formData, [name]: value })
    }

    // File list selection event
    const handleFileListSelection = (filename: string, isChecked: boolean) => {
        if (isChecked) {
            setSingleSelectedFile(filename)
            setSelectedFiles([filename])
        } else {
            setSingleSelectedFile(null)
            setSelectedFiles([])
        }
    }

    const handleFileListChange = (data: any) => {
        console.log({ data, value: data.value })
        setSingleSelectedFile(data.value)
        setSelectedFiles([data.value])
    }

    // Click Add New button to add to list
    const addNew = () => {
        // Only allow add new when there's no edit gioing on
        const isEditModeOn = data.find((dt: any) => dt.isEditMode);
        if (isEditModeOn) return;

        setIsAddNew(true)
        let clonedData: any[] = cloneDeep(data);
        const newPayload = {
            all_data: {
                'first name': '',
                'last name': '',
                'email': ''
            },
            eventId: eventId,
            isEditMode: true,
            selected: false
        }

        clonedData.unshift(newPayload)
        setData(clonedData)

        setFormData({
            'first name': '',
            'last name': '',
            'email': ''
        })

    }

    // Add new data with API call
    const confirmAddItem = async () => {
        // Validate data
        const isValid = validateData()
        if (!isValid) return

        setIsAddNew(false);
        const index = 0;
        const clonedData = cloneDeep(data);

        clonedData[index]['isEditMode'] = false;
        clonedData[index]['all_data']['first name'] = formData?.['first name'] ? formData?.['first name'] : clonedData[index]['all_data']['first name']
        clonedData[index]['all_data']['last name'] = formData?.['last name'];
        clonedData[index]['all_data']['email'] = formData?.email ? formData?.email : clonedData[index]['all_data']['email']
        clonedData[index]['list_type'] = 'attendee'
        clonedData[index]['original_file_name'] = 'Fetebuddy'
        setData(clonedData);

        const addPayload = {
            eventId,
            list_type: 'attendee',
            file_name: selectedFiles[0],
            original_file_name: 'Fetebuddy',
            all_data: {
                'email': formData?.email ? formData?.email : clonedData[index]['all_data']['email'],
                'first name': formData?.['first name'] ? formData?.['first name'] : clonedData[index]['all_data']['first name'],
                'last name': formData?.['last name']
            }
        }

        try {
            await addAttendeeFromList(addPayload);
            const totalLength = totalData + 1;
            setTotalData(totalLength)
            setFilePayload(selectedFiles)
            Toast.success('', 'Data added successfully')
        } catch (error) {
            Toast.error('', 'Failed to add data')
        }
    }

    const validateData = () => {
        if (!formData['first name']) {
            Toast.error('', 'First name cannot be empty')
            return false
        }
        if (!formData['email']) {
            Toast.error('', 'Email cannot be empty')
            return false
        }
        return true
    }

    return (
        <div className='border border-[#EAECF0] rounded-xl mb-6'>
            {
                showDeleteModal &&
                <ConfirmationModal
                    headerText={'Delete attendee(s)'}
                    bodyText={``}
                    mainText={`Are you sure you want to delete? Changes made cannot be undone.`}
                    setShowDeleteModal={setShowDeleteModal}
                    confirmDelete={confirmDelete}
                />
            }
            <div className='px-6 pt-5'>
                {
                    allFileList && allFileList?.length > 0 &&
                    <>
                        <div className="flex items-center gap-x-2 mb-2">
                            <span className='text-base font-interSemiBold text-[#101828]'>Select File</span>
                        </div>

                        <div className='modal-select-box fete-settings-modals w-1/3 mb-7'>
                            <CustomSelect
                                onChange={handleFileListChange}
                                options={allFileList}
                                menuPlacement="top"
                            />
                        </div>
                    </>
                }
                {
                    showFilesData &&
                    <div className="flex items-center gap-x-2 mb-5">
                        <span className='text-base font-interSemiBold text-[#101828]'>Attendees List</span>

                        <span className='bg-[#e8e6fe] border border-[#958de3] rounded px-2 py-0.5 inline-block text-sm text-[#1E0AF5] font-interSemiBold'>
                            {totalData}
                        </span>
                    </div>
                }

                {
                    showFilesData &&
                    <>
                        <div className='flex items-center mb-6 justify-between w-full'>
                            <form onSubmit={(e: any) => handleSearch(e, false)} className="flex items-center">
                                <div className={`border hover:border-[#1E0AF5] rounded-lg w-80 py-2.5 px-3.5 flex items-center gap-x-2 ${isFocused ? "border-[#1e0af5]" : "border-[#D0D5DD]"}`}>
                                    <img src={allImgPaths.searchIcon} alt="search" />
                                    <input
                                        className="w-full"
                                        placeholder="Search by Name or Email"
                                        type="text"
                                        onChange={(e) => setSearchText(e.target.value)}
                                        value={searchText}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        onInput={handleInput}
                                    />
                                    {
                                        searchText &&
                                        <img
                                            className='cursor-pointer hover:bg-[#FEE4E2] rounded w-5 p-1'
                                            src={allImgPaths.closeIconRed}
                                            alt=""
                                            onClick={(e) => {
                                                setSearchText('');
                                                handleSearch(e, true)
                                            }}
                                        />
                                    }
                                </div>
                                <button
                                    type='submit'
                                    className={`submit-btn-blue !px-4 ml-5 !py-2.5 hover:bg-[#120693] ${searchText ? '' : 'button-disabled'}`}
                                    // onClick={() => handleSearch(false)}
                                    disabled={searchText ? false : true}
                                >
                                    Search
                                </button>
                            </form>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-x-3">
                                    <button
                                        type='button'
                                        className={`text-[#344054] font-interSemiBold border border-[#D0D5DD] hover:border-[#1E0AF5]  rounded-lg tracking-wide py-2.5 px-3 !text-base flex justify-center items-center gap-x-1.5 ${totalSelected == 0 ? 'button-disabled' : ''}`}
                                        onClick={deleteItemModal}
                                        disabled={totalSelected == 0}
                                    >
                                        <img src={allImgPaths.deleteIcon2} alt="plus" />
                                        Delete
                                    </button>
                                    <button
                                        className={`submit-btn-blue flex justify-center items-center gap-x-2 !px-5 hover:bg-[#120693] ${isAddNew ? 'button-disabled hover:bg-[#F2F4F7]' : ''}`}
                                        disabled={isAddNew}
                                        onClick={addNew}>
                                        <img src={allImgPaths.plusIcon} alt="plus" />
                                        Add New
                                    </button>
                                </div>
                            </div>

                        </div>
                        {loading && <ExistingSettingMemberLoader />}
                        {
                            !loading && data && data?.length > 0 &&
                            <>
                                <div className="overflow-x-auto w-[calc(100vw_-_614px)]">
                                    <div className="custom-table-grid-attendees-list-edit whitespace-nowrap">
                                        {
                                            allKeys?.length > 0 && allKeys.map((key: any, kIndex: number) => (
                                                <React.Fragment key={kIndex}>
                                                    {
                                                        kIndex == 0 &&
                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r first-of-type:rounded-tl-lg last-of-type:rounded-tr-lg'>
                                                            <input
                                                                type="checkbox"
                                                                name={'all'}
                                                                onChange={(e: any) => handleSelection('all', e.target.checked)}
                                                                checked={allSelected}
                                                                className='w-4 h-4 cursor-pointer ml-2'
                                                            />
                                                            <span
                                                                className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center"
                                                                onClick={() => handleSort(key)}
                                                            >
                                                                {key}
                                                                {/* <img onClick={() => handleSort(key)} className={`w-4 cursor-pointer transform ${arrowUp ? "rotate-0" : "rotate-180"}`} src={allImgPaths.arrowUp3} alt="" /> */}
                                                                <img
                                                                    className={`w-4 cursor-pointer transform ${(sortField === key && sortOrder == 'asc') ? "rotate-0" : "rotate-180"}`}
                                                                    src={allImgPaths.arrowUp3} alt=""
                                                                />
                                                            </span>
                                                        </div>
                                                    }
                                                    {
                                                        kIndex > 0 &&
                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r first-of-type:rounded-tl-lg last-of-type:rounded-tr-lg'>
                                                            <span
                                                                className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center"
                                                                onClick={() => handleSort(key)}
                                                            >
                                                                {key}
                                                                {
                                                                    key != 'Action' &&
                                                                    // <img onClick={() => handleSort(key)} className={`w-4 cursor-pointer ${arrowUp ? "rotate-0" : "rotate-180"}`} src={allImgPaths.arrowUp3} alt="" />
                                                                    <img
                                                                        className={`w-4 cursor-pointer transform ${(sortField === key && sortOrder == 'asc') ? "rotate-0" : "rotate-180"}`}
                                                                        src={allImgPaths.arrowUp3} alt=""
                                                                    />
                                                                }
                                                            </span>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>


                                    <div className="custom-table-grid-attendees-list-edit max-h-[calc(100vh_-_680px)]">
                                        {
                                            allKeys?.length > 0 && allKeys.map((key: any, kIndex: number) => (
                                                <div className="min-w-[220px] flex flex-col border border-[#EAECF0] border-r-0 last:border-r" key={kIndex}>
                                                    {
                                                        data?.length > 0 && data.map((dt: any, index: number) => (
                                                            <React.Fragment key={index}>

                                                                {/* Non-Edit Mode HTML */}
                                                                {
                                                                    !dt.isEditMode &&
                                                                    <React.Fragment key={index}>
                                                                        {
                                                                            kIndex == 0 &&
                                                                            <div className='flex items-center gap-x-3 py-3 px-2 border-b last:border-b-0 border-[#EAECF0] checkbox-alignment'>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={dt?._id || ''}
                                                                                    name={dt?._id || ''}
                                                                                    onChange={(e: any) => handleSelection(dt?._id, e.target.checked)}
                                                                                    checked={dt?.selected || false}
                                                                                    className='w-4 h-4 cursor-pointer'
                                                                                />
                                                                                <div className="flex gap-x-3 items-center">
                                                                                    <p className='text-[#101828] text-sm font-interMedium'>
                                                                                        {dt.all_data[key] || '-'}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {
                                                                            kIndex > 0 &&
                                                                            <div className="py-3 px-2 flex gap-x-3 items-center border-b last:border-b-0 border-[#EAECF0]">
                                                                                {
                                                                                    key != 'Action' &&
                                                                                    <p title={dt.all_data[key] || '-'} className='text-[#101828] text-sm font-interMedium truncate max-w-52'>
                                                                                        {dt.all_data[key] || '-'}
                                                                                    </p>
                                                                                }
                                                                                {
                                                                                    key == 'Action' &&
                                                                                    <div className="w-full flex justify-center -my-0.5">
                                                                                        <span className='on-hover-bg-blue rounded p-1 cursor-pointer'>
                                                                                            <img
                                                                                                className='w-4 h-4 cursor-pointer'
                                                                                                src={allImgPaths.EditIcon}
                                                                                                alt=""
                                                                                                onClick={() => editItem(dt?._id)}
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        }
                                                                    </React.Fragment>
                                                                }

                                                                {/* Edit Mode HTML */}
                                                                {
                                                                    dt.isEditMode &&
                                                                    <React.Fragment key={index}>
                                                                        {
                                                                            kIndex == 0 &&
                                                                            <div className="flex gap-x-3 items-center py-[7px] px-2 border-b border-[#EAECF0]" key={index}>
                                                                                {
                                                                                    key != 'Action' &&
                                                                                    <>
                                                                                        {
                                                                                            !isAddNew &&
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={dt?._id || ''}
                                                                                                name={dt?._id || ''}
                                                                                                onChange={(e: any) => handleSelection(dt?._id, e.target.checked)}
                                                                                                checked={dt?.selected || false}
                                                                                                className='w-4 h-4 cursor-pointer'
                                                                                            />
                                                                                        }
                                                                                        <p className='text-[#101828] text-sm font-interMedium'>
                                                                                            <input
                                                                                                className="border rounded w-[180px] py-1 px-2"
                                                                                                type="text"
                                                                                                name={key}
                                                                                                id={key}
                                                                                                value={formData[key]}
                                                                                                onChange={(e) => handleTextChange(key, e.target.value)}
                                                                                            />

                                                                                        </p>
                                                                                    </>
                                                                                }
                                                                                {
                                                                                    key == 'Action' &&
                                                                                    <div>
                                                                                        <img onClick={() => cancelEditItem(dt?._id)} src={allImgPaths.closeIconRed} alt="" />
                                                                                        {
                                                                                            isAddNew &&
                                                                                            <img onClick={confirmAddItem} src={allImgPaths.RightCheckGreenIcon} alt="" />
                                                                                        }
                                                                                        {
                                                                                            !isAddNew &&
                                                                                            <img onClick={() => confirmEditItem(dt?._id)} src={allImgPaths.RightCheckGreenIcon} alt="" />
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        }
                                                                        {
                                                                            kIndex > 0 &&
                                                                            <div className="flex gap-x-3 items-center py-[7px] px-2 border-b border-[#EAECF0]" key={index}>
                                                                                {
                                                                                    key != 'Action' &&
                                                                                    <p className='text-[#101828] text-sm font-interMedium'>
                                                                                        {/* {dt.all_data[key] || '-'} */}
                                                                                        <input
                                                                                            className="border rounded w-[180px] py-1 px-2"
                                                                                            type="text"
                                                                                            name={key}
                                                                                            id={key}
                                                                                            value={formData[key]}
                                                                                            onChange={(e) => handleTextChange(key, e.target.value)}
                                                                                        />

                                                                                    </p>
                                                                                }
                                                                                {
                                                                                    key == 'Action' &&
                                                                                    <div className='flex items-center gap-x-3 justify-center w-full py-[3px]'>
                                                                                        <span className='on-hover-bg-red rounded p-1.5 cursor-pointer' onClick={() => cancelEditItem(dt?._id)}>
                                                                                            <img src={allImgPaths.closeIconRed} alt="" />
                                                                                        </span>

                                                                                        {
                                                                                            isAddNew &&
                                                                                            <span
                                                                                                onClick={confirmAddItem} className='on-hover-bg-green rounded p-[5px] cursor-pointer'>
                                                                                                <img className='w-[14px] h-[14px]' src={allImgPaths.RightCheckGreenIcon} alt="" />
                                                                                            </span>

                                                                                        }
                                                                                        {
                                                                                            !isAddNew &&
                                                                                            <span
                                                                                                onClick={() => confirmEditItem(dt?._id)} className='on-hover-bg-green rounded p-[5px] cursor-pointer'>
                                                                                                <img className='w-[14px] h-[14px]' src={allImgPaths.RightCheckGreenIcon} alt="" />
                                                                                            </span>
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        }
                                                                    </React.Fragment>
                                                                }
                                                            </React.Fragment>
                                                        ))
                                                    }

                                                </div>
                                            ))
                                        }
                                    </div>

                                </div>

                                {/* Pagination Box */}
                                <div className="flex w-full items-center mt-5 mb-5">
                                    <div>
                                        <select
                                            value={perPage}
                                            onChange={handlePerPageChange}
                                            className='mr-5 border border-[#ccc] px-3 py-1.5 rounded-md' id="numberDropdown" name="numberDropdown">
                                            {
                                                pageOptions.map((po: any, index: number) => (
                                                    <option value={po} key={index}>
                                                        {po}
                                                    </option>
                                                ))
                                            }
                                        </select>

                                    </div>

                                    <div className="flex items-center gap-x-1">
                                        <span className='text-sm text-[#344054] font-interMedium'>Page</span>
                                        <span className='text-sm text-[#344054] font-interMedium'>{currentPage}</span>
                                        <span className='text-sm text-[#344054] font-interMedium'>of</span>
                                        <span className='text-sm text-[#344054] font-interMedium'>
                                            {finalPage}
                                        </span>
                                    </div>
                                    <div className="flex items-center gap-x-1.5">
                                        {
                                            (currentPage != 1 || currentPage == finalPage) && totalData > perPage &&
                                            <img
                                                className='cursor-pointer'
                                                src={allImgPaths.pagiLeftBtn}
                                                alt=""
                                                onClick={() => handlePageChange(currentPage - 1)} />
                                        }
                                        {
                                            currentPage != finalPage &&
                                            <img
                                                className='cursor-pointer'
                                                src={allImgPaths.pagiRightBtn}
                                                alt=""
                                                onClick={() => handlePageChange(currentPage + 1)} />
                                        }
                                    </div>
                                </div>
                            </>
                        }
                        {
                            !loading && !data?.length &&
                            <div className='ml-3'>
                                <h3>No Attendees Available</h3>
                            </div>
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default ViewListItem